import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { getOrganisation, updateOrganisation } from '../redux/organisationActions';
import { BackButton, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import OrganisationForm from '../components/OrganisationForm/OrganisationForm';

const OrganisationEditContainer = ({
  onUpdateOrganisation,
  onGetOrganisation,
  params: { id },
}) => {
  useEffect(
    () => {
      onGetOrganisation(id, ['channel_access', 'organisation_type', 'legal_entity_type']);
    },
    [id, onGetOrganisation],
  );

  const resource = useSelector((state) => state?.organisation?.resources?.[id]);

  const update = (values) => {
    return onUpdateOrganisation(values);
  };

  if (!resource) {
    return (
      <InternalContainer title="Organisation" buttons={<BackButton />}>
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer title="Organisation" buttons={<BackButton />}>
      <OrganisationForm resource={resource} onSave={update} />
    </InternalContainer>
  );
};
export default connect(
  null,
  {
    onUpdateOrganisation: updateOrganisation,
    onGetOrganisation: getOrganisation,
  },
)(OrganisationEditContainer);
